// The one thing the person types inside a bill popup: an amount to pay, or a
// short message saying why they object to the amount.
function BillActionInput({ id, label, hint = "", type = "amount", value, error = "", maxLength, disabled = false, onChange }) {
  const fieldClass = `w-full rounded-xl border bg-white px-3 py-2.5 text-sm text-slate-900 focus:outline-none focus:ring-2 ${
    error ? "border-rose-300 focus:border-rose-400 focus:ring-rose-100" : "border-slate-300 focus:border-teal-500 focus:ring-teal-100"
  }`
  const describedBy = `${id}-help`

  return (
    <div>
      <label htmlFor={id} className="mb-1 block text-xs font-bold text-slate-700">
        {label}
      </label>
      {type === "message" ? (
        <textarea
          id={id}
          rows={3}
          value={value}
          maxLength={maxLength}
          disabled={disabled}
          onChange={(event) => onChange(event.target.value)}
          aria-invalid={Boolean(error)}
          aria-describedby={describedBy}
          className={`${fieldClass} resize-none`}
        />
      ) : (
        <input
          id={id}
          type="text"
          inputMode="decimal"
          autoComplete="off"
          value={value}
          disabled={disabled}
          onChange={(event) => onChange(event.target.value.replace(/,/g, ""))}
          aria-invalid={Boolean(error)}
          aria-describedby={describedBy}
          className={`${fieldClass} tabular-nums`}
        />
      )}
      <p id={describedBy} className={`mt-1 text-[11px] ${error ? "font-semibold text-rose-600" : "text-slate-500"}`}>
        {error || hint}
      </p>
    </div>
  )
}

export default BillActionInput
